export const CHART_TYPES = {
    GRAFICO_BARRA: 1,
    GRAFICO_BARRA_APILABLE: 2,
    GRAFICO_BARRA_AGRUPADA: 3,
    GRAFICO_LINEAL: 4,
    GRAFICO_TORTA: 5,
    MAPA: 6,
    MAPA_CALOR: 7,
    GRAFICO_DOBLE_EJE_Y: 8,
} as const;

export type ChartTypeValue = typeof CHART_TYPES[keyof typeof CHART_TYPES];

export type ChartTypeKey = keyof typeof CHART_TYPES;

export const CHART_TYPE_NAMES: Record<ChartTypeValue, ChartTypeKey> = {
    1: 'GRAFICO_BARRA',
    2: 'GRAFICO_BARRA_APILABLE',
    3: 'GRAFICO_BARRA_AGRUPADA',
    4: 'GRAFICO_LINEAL',
    5: 'GRAFICO_TORTA',
    6: 'MAPA',
    7: 'MAPA_CALOR',
    8: 'GRAFICO_DOBLE_EJE_Y',
};

export interface ChartConfig {
    id: ChartTypeValue;
    name: string;
    requiresVariableAnalisis: boolean;
    requiresDomain: boolean;
    supportsMultipleYAxis: boolean;
    dataType: 'chart' | 'map';
}

export const CHART_CONFIGS: Record<ChartTypeValue, ChartConfig> = {
    [CHART_TYPES.GRAFICO_BARRA]: {
        id: CHART_TYPES.GRAFICO_BARRA,
        name: 'Gráfico de Barras',
        requiresVariableAnalisis: true,
        requiresDomain: true,
        supportsMultipleYAxis: false,
        dataType: 'chart',
    },
    [CHART_TYPES.GRAFICO_BARRA_APILABLE]: {
        id: CHART_TYPES.GRAFICO_BARRA_APILABLE,
        name: 'Gráfico de Barras Apilables',
        requiresVariableAnalisis: true,
        requiresDomain: true,
        supportsMultipleYAxis: false,
        dataType: 'chart',
    },
    [CHART_TYPES.GRAFICO_BARRA_AGRUPADA]: {
        id: CHART_TYPES.GRAFICO_BARRA_AGRUPADA,
        name: 'Gráfico de Barras Agrupadas',
        requiresVariableAnalisis: true,
        requiresDomain: true,
        supportsMultipleYAxis: false,
        dataType: 'chart',
    },
    [CHART_TYPES.GRAFICO_LINEAL]: {
        id: CHART_TYPES.GRAFICO_LINEAL,
        name: 'Gráfico Lineal',
        requiresVariableAnalisis: true,
        requiresDomain: true,
        supportsMultipleYAxis: false,
        dataType: 'chart',
    },
    [CHART_TYPES.GRAFICO_TORTA]: {
        id: CHART_TYPES.GRAFICO_TORTA,
        name: 'Gráfico de Torta',
        requiresVariableAnalisis: false,
        requiresDomain: false,
        supportsMultipleYAxis: false,
        dataType: 'chart',
    },
    [CHART_TYPES.MAPA]: {
        id: CHART_TYPES.MAPA,
        name: 'Mapa',
        requiresVariableAnalisis: false,
        requiresDomain: false,
        supportsMultipleYAxis: false,
        dataType: 'map',
    },
    [CHART_TYPES.MAPA_CALOR]: {
        id: CHART_TYPES.MAPA_CALOR,
        name: 'Mapa de Calor',
        requiresVariableAnalisis: false,
        requiresDomain: false,
        supportsMultipleYAxis: false,
        dataType: 'map',
    },
    [CHART_TYPES.GRAFICO_DOBLE_EJE_Y]: {
        id: CHART_TYPES.GRAFICO_DOBLE_EJE_Y,
        name: 'Gráfico de Doble Eje Y',
        requiresVariableAnalisis: true,
        requiresDomain: true,
        supportsMultipleYAxis: true,
        dataType: 'chart',
    },
};

export const isChartType = (value: any): value is ChartTypeValue => {
    return Object.keys(CHART_CONFIGS).includes(String(value));
};

export const isMapType = (type: ChartTypeValue): boolean => {
    return CHART_CONFIGS[type]?.dataType === 'map';
};

export const requiresVariableAnalisis = (type: ChartTypeValue): boolean => {
    return CHART_CONFIGS[type]?.requiresVariableAnalisis ?? false;
};

export const CHART_CONFIG = {
  STROKE_DASH: "3 3",
  STROKE_COLOR: "#555C62",
  TICK_FONT_SIZE: 14,
  STROKE_WIDTH: 2,
  LEGEND_FONT_SIZE: '0.875rem',
  MARGINS: { top: 10, right: 30, left: 20, bottom: 5 },
} as const;